import { defineMessages } from '@edx/frontend-platform/i18n'

const messages = defineMessages({
  "wishlistEmpty": {
    id: "pages.wishlist.wishlistEmpty",
    defaultMessage: "No items in your wishlist",
    description: "Wishlist empty"
  },
  "relevent": {
    id: "pages.wishlist.relevent",
    defaultMessage: "Relevent",
    description: "Relevent"
  },
  "atoz": {
    id: "pages.wishlist.atoz",
    defaultMessage: "A to Z",
    description: "A to Z"
  },
  "ztoa": {
    id: "pages.wishlist.ztoa",
    defaultMessage: "Z to A",
    description: "Z to A"
  },
  "upcoming": {
    id: "pages.wishlist.upcoming",
    defaultMessage: "Upcoming",
    description: "Upcoming"
  },
  "search": {
    id: "pages.wishlist.search",
    defaultMessage: "Search",
    description: "Search"
  }
});

export default messages;